import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import mcLib from '../../utilities/mc-lib';

export class McMenu extends Component {
  componentDidMount() {
    this.registerMcMenu();
    this.wireMcEventListener();
  }

  onMcNavTriggered(dataReceived) {
    this.props.history.push(dataReceived.options.url);
  }

  wireMcEventListener() {
    mcLib.on(
      'etmcNavigationTriggered',
      'marketing-cloud',
      this.onMcNavTriggered.bind(this)
    );
  }

  registerMcMenu() {
    const menu = [
      'analytics',
      'distribution',
      ['settings', 'classes', 'attributes', 'rules', 'profiles', 'fallback']
    ].map(menuItem => {
      const { formatMessage } = this.props.intl;
      const i18nKey = 'components.ecs.menu';
      const name = Array.isArray(menuItem) ? menuItem[0] : menuItem;
      const url = '/' + name;
      return {
        name: formatMessage({ id: `${i18nKey}.${name}` }),
        options: { url },
        selected: [menuItem]
          .flat()
          .some(name => this.props.route.toLowerCase().includes(name))
      };
    });

    mcLib.getAppInfo({ appName: this.appName() }, function(data) {
      const appId =
        data['appInfo'] && data['appInfo']['applicationId']
          ? data['appInfo']['applicationId']
          : '';
      //register menu to MC
      mcLib.registerAppMenu(menu, appId, function(menudata) {});
    });
  }

  appName() {
    const host = window?.location?.hostname;
    if (host && host.startsWith('ecs.alot')) {
      return 'Einstein Content Selection (Alot)';
    }
    return 'Einstein Content Selection';
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

McMenu.propTypes = {
  history: PropTypes.object.isRequired,
  route: PropTypes.string.isRequired
};

export default injectIntl(McMenu);
